import { render, staticRenderFns } from "./MyExamineView.vue?vue&type=template&id=2ff72076"
import script from "./MyExamineView.vue?vue&type=script&lang=js"
export * from "./MyExamineView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports